/*
 * @Descripttion: 风格改变后相应的方法
 * @Author: shenah
 * @Date: 2023-06-06 16:17:47
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:33:40
 */
export default {
  methods: {
    styleConfigCallback(styleObj) {
      // 改变series
      // this.handleStyleChangeSeries(styleObj)
      // 改变options最外层的属性(不是特殊一些属性)
      // this.handleStyleChangeOptionAttr(styleObj);
      Object.keys(this.chart).forEach((key) => {
        switch (key) {
          case "xAxis":
          case "yAxis":
          case "radiusAxis":
          case "angleAxis":
            this.handleStyleChangeAxis(styleObj.axis, key);
            break;
          case "radar":
            this.handleStyleChangeRadar(styleObj.axis);
            break;
          case "legend":
            this.handleStyleChangeObjValue(
              [["textStyle.color", styleObj.legend.labelColor]],
              this.chart[key]
            );
            break;
          case "title":
            this.handleStyleChangeObjValue(
              [["textStyle.color", styleObj.title.labelColor]],
              this.chart[key]
            );
            break;
          case "series":
            this.handleStyleChangeSeries(styleObj);
            break;
        }
      });
      this.chartString =  dsf.dataview.utils.objectTostring(this.chart, true);
      this.reset();
    },
    /**
     * @name: 处理Series
     * @param {*} styleObj 风格对象
     * @return {*}
     */
    handleStyleChangeSeries(styleObj, chart = this.chart) {
      let itemColors = styleObj.commonStyle.colors;
      let series = chart.series;
      const labelColor = styleObj.commonStyle.labelColor;
      const name = this.ctrlName;
      const dataTypes = ["funnel", "radar", "pie", "treemap"];
      const seriesType = [
        "bar",
        "line",
        "custom",
        "pictorialBar",
        "scatter",
        "effectScatter",
      ];
      // 取色逻辑当series中有多种类型时，取公共的颜色
      const typeCount = Array.from(new Set(series.map((item) => item.type)));
      // 只有一种类型时，可以取同类型的颜色值，否则只能用公用颜色
      if (typeCount === 1 && styleObj?.commonStyle[it.type + "Colors"]) {
        itemColors = styleObj.commonStyle[it.type + "Colors"];
      }
      // 组件内部自定义颜色更改方式，剥离开取色逻辑
      if (
        this.handleStyleChangeComponentSeries &&
        dsf.isFunction(this.handleStyleChangeComponentSeries)
      ) {
        this.handleStyleChangeComponentSeries({
          colors: itemColors,
          labelColor,
        });
        return;
      }
      series.forEach((it, index) => {
        const maxColorLength = itemColors.length;
        if (!(Array.isArray(itemColors) && maxColorLength)) {
          return null;
        }
        if (it.type === "map") {
          const mapColors = styleObj.map.colors;
          const mapLabelColor = styleObj.map.labelColor;
          const mapBorderColor = styleObj.map.borderColor;
          let color = this.handleStyleArrGetColor(mapColors, index);
          if (index > maxColorLength - 1) {
            return;
          }
          this.handleStyleChangeObjValue(
            [
              ["itemStyle.areaColor", color[2]],
              ["itemStyle.borderColor", mapBorderColor],
              ["label.color", mapLabelColor],
            ],
            it
          );
          return;
        }
        // 图谱
        if (it.type === "graph") {
          let color = this.handleStyleArrGetColor(itemColors, index);
          if (index > maxColorLength - 1) {
            return;
          }
          this.handleStyleChangeObjValue(
            [
              ["itemStyle.color", color[2]],
              ["label.color", labelColor],
            ],
            it
          );
          it.categories.forEach((item, idx) => {
            let colorItem = this.handleStyleArrGetColor(itemColors, idx);
            if (idx > maxColorLength - 1) {
              return;
            }
            this.handleStyleChangeObjValue(
              [
                ["itemStyle.color", colorItem[2]],
                ["label.color", labelColor],
              ],
              item
            );
          });
          return;
        }
        // 词云
        if (it.type === "wordCloud") {
          let color = this.handleStyleArrGetColor(itemColors, index);
          if (index > maxColorLength - 1) {
            return;
          }
          this.handleStyleChangeObjValue(
            [
              ["textStyle.color", color[2]],
              ["textStyle.oldColor", color[2]],
              ["textStyle.copyTextShadowColor", color[1]],
            ],
            it
          );
          return;
        }
        // 仪表盘
        if (it.type === "gauge") {
          let color = this.handleStyleArrGetColor(itemColors, index);
          if (index > maxColorLength - 1) {
            return;
          }
          // 业务组件不支持风格切换
          if (this.isBusiness) {
            return;
          }
          const gaugeColor = [
            [0.2, color[0]],
            [0.8, color[1]],
            [1, color[2]],
          ];
          this.handleStyleChangeObjValue(
            [
              ["axisLine.lineStyle.color", gaugeColor],
              ["axisLabel.color", labelColor],
            ],
            it
          );
          return;
        }
        // 适用于漏斗图、雷达图、饼图
        if (dataTypes.includes(it.type)) {
          this.handleStyleChangeObjValue([["label.color", labelColor]], it);
          it.data.forEach((item, idx) => {
            let color = this.handleStyleArrGetColor(itemColors, idx);
            if (idx > maxColorLength - 1) {
              return;
            }
            const renderMap = [
              ["itemStyle", [color[2], color[0]], false],
              ["label.color", labelColor],
              ["lineStyle.color", color[2]],
            ];
            // 饼图特别设置
            if (it.type === "pie" || it.type === "treemap") {
              renderMap[0][2] = true;
            }
            this.handleStyleChangeObjValue(renderMap, item);
          });
          return;
        }
        // 适用于柱状图、3D柱状图、象形图、折线图、散点图、折柱图、极坐标
        if (seriesType.includes(it.type)) {
          let color = this.handleStyleArrGetColor(itemColors, index);
          if (index > maxColorLength - 1) {
            return;
          }
          this.handleStyleChangeObjValue(
            [
              ["itemStyle", [color[2], color[0]], true],
              ["label.color", labelColor],
            ],
            it
          );
          // 3d柱状图颜色处理
          if (name === "DsfDataViewBar3d") {
            it.itemStyle.cubeColors = color.map((item) => [item, item]);
          }
        }
      });
    },

    /**
     * @name: 处理成echarts相应的配置颜色
     * @param {Array|String} color
     * @return {ColorObj} {
     *  color:Object | String,
     *  startColor:String,
     *  endColor:String,
     *  isshade:Boolean,
     * }
     */
    handleStyleChangeSingleEchartsColor(color, isshade) {
      const [startColor = "#fff", endColor = "#fff"] = color;
      let colorObj = {
        color: startColor,
        startColor: startColor,
        endColor: endColor,
      };
      if (isshade) {
        colorObj.color = {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 1,
              color: startColor,
            },
            {
              offset: 0,
              color: endColor,
            },
          ],
          global: false,
        };
      }
      return colorObj;
    },
    /**
     * @name: 根据所有color与index找到相应的color
     * @param {Array} colorArr
     * @param {Number} index
     * @return {String | Array} "#fff" | ["#fff","aaa"]
     */
    handleStyleArrGetColor(colorArr, index) {
      let maxColorLength = colorArr.length;
      let nowColorIndex = index <= maxColorLength ? index : maxColorLength;
      let color = colorArr[nowColorIndex];
      let renderColor = null;
      // 颜色处理成长度为3的数组
      if (dsf.isArray(color)) {
        renderColor =
          color.length === 3 ? color : [...color, ...color].slice(0, 3);
      } else {
        renderColor = [color, color, color];
      }
      return renderColor;
    },
    // 雷达图坐标系
    handleStyleChangeRadar(styleObj, chart = this.chart) {
      const radar = dsf.isArray(chart.radar) ? chart.radar : [chart.radar];
      radar.forEach((it) => {
        this.handleStyleChangeObjValue(
          [
            ["name.textStyle.color", styleObj.labelColor],
            ["axisLine.lineStyle.color", styleObj.lineColor],
          ],
          it
        );
      });
    },
    // 坐标系数据解析方式
    handleStyleChangeAxis(styleObj, axisType, chart = this.chart) {
      if (!styleObj) {
        return;
      }
      const map = [
        ["axisLabel.color", styleObj.labelColor],
        ["axisLine.lineStyle.color", styleObj.lineColor],
        ["nameTextStyle.color", styleObj.labelColor],
      ];
      if (dsf.isArray(chart[axisType])) {
        // 按照数组解析
        chart[axisType].forEach((it) => {
          it = this.handleStyleChangeObjValue(map, it);
        });
      } else if (dsf.isObject(chart[axisType])) {
        // 按照对象解析
        chart[axisType] = this.handleStyleChangeObjValue(map, chart[axisType]);
      }
    },
    // 改变对象对应的属性值
    handleStyleChangeObjValue(map = [], obj) {
      if (!map || !map.length) {
        return obj;
      }
      map.forEach((it) => {
        // 跳出当前循环
        if (!it || !it.length) {
          return;
        }
        // type为false，表示直接赋值；type为true，表示覆盖
        const [targetString, value, type = false] = it;
        // it按照.的方式解析
        if (!targetString) {
          return;
        }
        const strTranferMap = ("" + targetString).split(".");
        let opt = obj;
        strTranferMap.forEach((item, idx) => {
          if (!opt || !opt[item]) {
            return null;
          }
          if (idx === strTranferMap.length - 1 && !dsf.isUnDef(value)) {
            const obj = dsf.isObject(opt[item])
              ? {
                ...opt[item],
                ...this.handleStyleChangeSingleEchartsColor(
                  value,
                  opt[item].isshade
                ),
              }
              : { obj };
            opt[item] = !type ? value : obj;
            return;
          }
          opt = opt[item];
        });
      });
      return obj;
    },
  },
};
